import { render, staticRenderFns } from "./TokenExpandable.vue?vue&type=template&id=c205fa44&scoped=true&"
import script from "./TokenExpandable.vue?vue&type=script&lang=ts&"
export * from "./TokenExpandable.vue?vue&type=script&lang=ts&"
import style0 from "./TokenExpandable.vue?vue&type=style&index=0&id=c205fa44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c205fa44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
